<template>
  <TableLayout v-permissions="['module:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline @submit.native.prevent>
      <el-form-item label="模块名称" prop="name">
        <el-input v-model="searchForm.name" v-trim placeholder="请输入模块名称" @keypress.enter.native="search"/>
      </el-form-item>
      <el-form-item label="所属行业" prop="name">
        <el-input v-model="searchForm.initIndustry" v-trim placeholder="请输入所属行业" @keypress.enter.native="search"/>
      </el-form-item>
      <el-form-item label="ID" prop="id">
        <el-input v-model="searchForm.id" placeholder="请输入ID" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['module:create', 'module:delete']">
        <li><el-button type="primary" @click="$refs.operaModuleWindow.open('新建模块')" icon="el-icon-plus" v-permissions="['module:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['module:delete']">删除</el-button></li>
      </ul>
      <el-table
        ref="table"
        v-loading="isWorking.search"
        :data="tableData.list"
        row-key="id"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" fixed="left" width="55"></el-table-column>
        <el-table-column prop="id" fixed="left" label="记录ID" min-width="100px"></el-table-column>
        <el-table-column prop="name" fixed="left" label="模块名称" min-width="120px"></el-table-column>
        <el-table-column prop="enName" fixed="left" label="模块英文名称" min-width="120px"></el-table-column>
        <!--        <el-table-column prop="description" label="模块描述" min-width="200px">-->
<!--          <ColumnDetail slot-scope="{ row }" :content="row.description" :limit="50"/>-->
<!--        </el-table-column>-->
        <el-table-column prop="initIndustry" label="初始行业" min-width="100px"></el-table-column>
        <el-table-column prop="inputFrom" label="录入方式" min-width="100px">
          <template slot-scope="{ row }">{{row.inputFrom | inputFromText}}</template>
        </el-table-column>
        <el-table-column prop="viewConfig" label="展现形式" min-width="200px">
          <template slot-scope="{ row }">{{getViewTypeName(row)}}</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="200px"></el-table-column>
        <el-table-column prop="withEncrypt" label="是否固定" min-width="100px">
          <template slot-scope="{ row }">
            <template v-if="!row.isDirectory">{{row.fixed | YONText}}</template>
            <template v-else>/</template>
          </template>
        </el-table-column>
        <el-table-column prop="withEncrypt" label="是否加密" min-width="100px">
          <template slot-scope="{ row }">
            <template v-if="!row.isDirectory">{{row.withEncrypt | YONText}}</template>
            <template v-else>/</template>
          </template>
        </el-table-column>
        <el-table-column prop="createUserInfo.realname" label="创建人" min-width="100px"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="140px"></el-table-column>
        <el-table-column prop="updateUserInfo.realname" label="更新人" min-width="100px"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" min-width="140px"></el-table-column>
        <el-table-column
            v-if="containPermissions(['module:update', 'module:delete', 'module:create'])"
            label="操作"
            min-width="270"
            fixed="right"
        >
          <template slot-scope="{row, $index}">
            <el-button v-if="row.isDirectory" type="text" @click="$refs.operaModuleWindow.open('新建子模块', null, row)" icon="el-icon-plus" v-permissions="['module:create']">新建子模块</el-button>
            <el-button v-if="!row.isDirectory" type="text" @click="$refs.operaModuleFieldConfigWindow.open(row)" icon="el-icon-plus" v-permissions="['module:update']">配置字段</el-button>
            <el-button v-if="!row.isDirectory" type="text" @click="$refs.moduleDataTableWindow.open(row)" icon="el-icon-plus" v-permissions="['module:update']">配置数据</el-button>
            <el-button type="text" @click="$refs.operaModuleWindow.open('编辑模块', row)" icon="el-icon-edit" v-permissions="['module:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['module:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/编辑 -->
    <OperaModuleWindow ref="operaModuleWindow" @success="search"/>
    <!-- 字段配置 -->
    <OperaModuleFieldConfigWindow ref="operaModuleFieldConfigWindow" @success="search"/>
    <!-- 数据配置 -->
    <ModuleDataTableWindow ref="moduleDataTableWindow"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaModuleWindow from '@/components/module/OperaModuleWindow'
import OperaModuleFieldConfigWindow from '@/components/module/OperaModuleFieldConfigWindow'
import ModuleDataTableWindow from '@/components/module/ModuleDataTableWindow'
import { findByType } from '../../api/template/parameter'
import ColumnDetail from '../../components/common/ColumnDetail'

export default {
  name: 'management',
  extends: BaseTable,
  components: { ColumnDetail, ModuleDataTableWindow, OperaModuleFieldConfigWindow, OperaModuleWindow, Pagination, TableLayout },
  data () {
    return {
      searchForm: {
        name: '',
        id: null
      },
      tableData: {
        // 列表
        list: []
      },
      viewTypeList: []
    }
  },
  methods: {
    // 获取展现形式名称
    getViewTypeName (row) {
      if (row.viewConfig == null || row.viewConfig === '') {
        return '未配置'
      }
      const names = []
      let viewConfigList = []
      try {
        viewConfigList = JSON.parse(row.viewConfig)
      } catch (e) {
      }
      for (const vc of viewConfigList) {
        const targetType = this.viewTypeList.find(type => type.code === vc)
        if (targetType == null) {
          continue
        }
        names.push(targetType.name)
      }
      return names.join(',')
    },
    // 查询展示形式列表
    fetchViewTypeList () {
      findByType({
        typeVariable: 'viewType',
        scope: 'MODULE'
      })
        .then(data => {
          this.viewTypeList = data
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
    }
  },
  created () {
    this.config({
      module: '模块',
      api: '/module/management',
      'field.id': 'id',
      'field.main': 'name'
    })
    this.fetchViewTypeList()
    this.search()
  }
}
</script>

<style scoped>

</style>
